module.exports = __webpack_public_path__ + "static/media/GuruMe_Office_Room1_2.50c14af9.jpg";